import React, { useEffect } from 'react';
import '@/App.css';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '@chakra-ui/react';

import { loginFromLocalStorage } from '@store/actions/authActions';
import { clearAlert, setAlert } from '@store/actions/alertActions';
import { initializeDeviceId } from '@utils';

import AuthenticatedApp from '@routes/authenticatedRoutes';
import UnauthenticatedApp from '@routes/unAuthenticatedRoutes';
import FullPageSpinner from '@components/FullPageSpinner';
import { ALERT_STATUS_TYPE } from '@constants';


const App = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const { user, isLoading } = useSelector((state) => state.auth);
  const { alert } = useSelector((state) => state);

  useEffect(() => {
    initializeDeviceId();
    handleLoginFromLocalStorage();
  }, [dispatch]);

  useEffect(() => {
    if (!alert.isActive || !alert.data) return;

    toast(alert.data);

    const timeout = setTimeout(() => {
      dispatch(clearAlert());
    }, alert.data.duration || 3000);

    return () => clearTimeout(timeout);
  }, [alert, dispatch, toast]);

  const handleLoginFromLocalStorage = () => {
    dispatch(
      loginFromLocalStorage({
        onSuccess: () => {
          dispatch(setAlert({
            title: 'Successfully Logged in to Alphadesk!',
            status: ALERT_STATUS_TYPE.SUCCESS
          }))
        }
      })
    )
  }
  if (isLoading) return <FullPageSpinner />;
  return user ? <AuthenticatedApp /> : <UnauthenticatedApp />;
}

export default App;
